import AboutXpKnowMoreDialog from './AboutXpKnowMoreDialog';

const FALLBACK_CONTENT = {
  title: 'Know About VIP Rooms',
  sections: [
    {
      heading: 'What is VIP Rooms?',
      body:
        'VIP Rooms are tokens that help you create a private space to have fun with family and friends privately. There are 3 types of rooms: Family, Kitty Party, and Corporate.',
    },
    {
      heading: 'How to Get VIP Rooms?',
      body: 'VIP Rooms can be obtained through the app during special offers or anytime from the coin store.',
    },
    {
      heading: 'How to Use VIP Rooms?',
      body:
        'In the RapHousie game, use a Room token to create a private room. Once created, the room owner gets a unique join code. Share this code with only the people you want to invite. They can enter the room using that code. No one else can join.',
    },
  ],
};

/** Figma 11059:1092–11002 — Know About VIP Rooms dialog */
export default function VipRoomKnowMoreDialog({ open, onClose }) {
  return <AboutXpKnowMoreDialog open={open} onClose={onClose} slug="rooms" fallbackContent={FALLBACK_CONTENT} />;
}
